import { differenceInDays, parse } from 'date-fns';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
function getLengthOfStay(startDate, endDate) {
  if (startDate && endDate) {
    var difference = differenceInDays(parse(endDate, PRICELINE_DATE_FORMAT, new Date()), parse(startDate, PRICELINE_DATE_FORMAT, new Date()));
    return "(".concat(difference, " ").concat(difference === 1 ? 'night' : 'nights', ")");
  }
  return '';
}
export default getLengthOfStay;